import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";

import CompetitionOverview from "@/components/CompetitionOverview/CompetitionOverview";
import { CompetitionContextProvider } from "@/components/CompetitionOverview/CompetitionProvider";
import CompetitionDetailsForm from "@/components/CompetitionProfile/CompetitionDetailsForm";
import CompetitionProfile from "@/components/CompetitionProfile/CompetitionProfile";

const Component = () => {
  const search = Route.useSearch();
  return (
    <CompetitionContextProvider collapseSelectorOnCompact>
      <CompetitionOverview initialTab="profile" leagueUuid={search.series}>
        <CompetitionProfile>
          <CompetitionDetailsForm startDate={search.startDate} leagueUuid={search.series} />
        </CompetitionProfile>
      </CompetitionOverview>
    </CompetitionContextProvider>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/events/create")({
  component: Component,
  validateSearch: (search?: Record<string, unknown> & SearchSchemaInput) => {
    return {
      startDate: (search?.startDate ?? undefined) as string | undefined,
      series: (search?.series ?? undefined) as string | undefined,
    };
  },
});
